import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pointer plr-10 co-F52F3E" }

import translate from '@/api/translate';
	
export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteVue',
  emits: ["change"],
  setup(__props, { emit: __emit }) {

	const emits = __emit;
	
	const Operate = () => {
		emits("change");
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { onClick: Operate }, _toDisplayString(_unref(translate).ShowText('删除')), 1)
  ]))
}
}

})